import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { NavLink } from 'react-router-dom';

const ServiceCard = ({ icon, title, desc, link = "/leistungen" }) => {
  return (
    <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-ms-light hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group flex flex-col h-full overflow-hidden">
      <div className="w-16 h-16 bg-ms-light rounded-xl flex items-center justify-center mb-8 group-hover:bg-ms-blue transition-colors duration-300 flex-shrink-0">
        <SafeIcon icon={icon} className="text-3xl text-ms-blue group-hover:text-white transition-colors" />
      </div>
      <h3 className="text-xl font-black text-ms-dark mb-4 uppercase tracking-tight break-words leading-tight">{title}</h3>
      <p className="text-ms-dark/70 mb-8 leading-relaxed flex-grow text-sm font-medium break-words hyphens-auto">
        {desc}
      </p>
      <NavLink to={link} className="inline-flex items-center font-bold text-ms-blue group-hover:text-ms-solar transition-colors uppercase text-sm tracking-widest mt-auto">
        Details ansehen <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-2 transition-transform" />
      </NavLink>
    </div>
  );
};

export default ServiceCard;